import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useSeo } from "@/hooks/useSeo";
import { api } from "@/lib/api";
import { PackageCard } from "@/components/PackageCard";
import { BookingModal } from "@/components/BookingModal";
import { motion } from "framer-motion";

const CATS = ["all", "religious", "leisure", "domestic", "international"];

export default function Packages() {
  const { t, lang } = useApp();
  useSeo({ title: t.seo.packages[0], description: t.seo.packages[1] });
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const active = params.get("cat") || "all";
  const dest = params.get("dest");
  const [groupDests, setGroupDests] = useState([]);
  useEffect(() => { if (dest) api.get("/group-destinations").then((r) => setGroupDests(r.data)).catch(() => {}); }, [dest]);
  const destObj = groupDests.find((g) => g.id === dest);
  const [packages, setPackages] = useState([]);
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    api.get(`/packages?${new URLSearchParams({ ...(active !== "all" ? { category: active } : {}), ...(dest ? { dest } : {}) })}`).then((r) => setPackages(r.data));
  }, [active, dest]);

  return (
    <div className="bg-sand min-h-screen">
      <div className="bg-tigris py-14 px-4 sm:px-6 text-center relative overflow-hidden">
        {destObj && <img src={destObj.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />}
        <div className="relative">
          <h1 className="text-white text-3xl sm:text-4xl font-bold font-display mb-3" data-testid="packages-title">
            {destObj ? `${t.sections.groupsTitle} — ${destObj[`name_${lang}`]}` : t.sections.groupsTitle}
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto">{t.sections.groupsSub}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {CATS.map((c) => (
            <button key={c} data-testid={`cat-${c}`} onClick={() => setParams(c === "all" ? {} : { cat: c })}
              className={`px-5 py-2.5 rounded-full text-sm font-bold transition ${active === c ? "bg-tigris text-white shadow-lg shadow-tigris/30" : "bg-white text-slate-600 hover:bg-slate-100"}`}>
              {t.categories[c]}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((p, i) => (
            <div key={p.id} onClick={() => navigate(`/packages/${p.id}`)} className="cursor-pointer">
              <PackageCard pkg={p} index={i} onBook={(pk) => setBooking({ type: "package", item_id: pk.id, title: pk[`name_${lang}`], amount: pk.price })} />
            </div>
          ))}
        </div>
      </div>
      {booking && <BookingModal item={booking} onClose={() => setBooking(null)} />}
    </div>
  );
}
